export const PasswordChange = {
  Title: 'Change password',
  CurrentPassword: 'Current password',
  NewPassword: 'New password',
  ConfirmNewPassword: 'Confirm new password',
  Submit: 'Change password',
  PasswordChanged: 'Password changed',
};
